import script from "./ExpandedTierView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandedTierView.vue?vue&type=script&setup=true&lang=js"

import "./ExpandedTierView.vue?vue&type=style&index=0&id=fa388732&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa388732"]])

export default __exports__